export interface IAgent {
    AgentId: number;
    FirstName: string;
    LastName: string;
    Email: string;
    CellPhone: string;
    OfficeId: number;
}

export class Agent implements IAgent {
    public AgentId = -1;
    public FirstName = '';
    public LastName = '';
    public Email = '';
    public CellPhone = '';
    public OfficeId = -1;
    constructor(
        agentObject: any,
    ) {
        this.AgentId = agentObject.AgentId;
        this.FirstName = agentObject.FirstName;
        this.LastName = agentObject.LastName;
        this.Email = agentObject.Email;
        this.CellPhone = agentObject.CellPhone;
        this.OfficeId = agentObject.OfficeId;
    }
}
